import { connect } from 'react-redux';
import MyPaymentBaseScreen from './my-payment.presentation';
import {
  setMyPaymentHistorySearchText, setMyPaymentSelectedTab, setMyPaymentSelectedInnerTab,
  setPredefinedOrderSearchText, setTappedOutstandingItemNo, setTappedPaymentHistoryProformaNo,
  setTappedTermBlNo,
} from '../../redux/action';
import {
  CART_TAB_CIP, PAYMENT_TYPE_DEPOSIT, PAYMENT_TYPE_TERM, PAYMENT_TYPE_CASH,
} from '../../constant';
import { isShowCartTabs } from '../../helper';

const getSelectedTab = (state) => {
  const { company } = state.currentUser;
  if (company && state.uiMyPayment.selectedTab === -1) {
    // userCompany && (userCompany.paymentMethod === PAYMENT_TYPE_CASH
    //   || userCompany.paymentMethod === PAYMENT_TYPE_TERM)

    if (company.paymentMethod === PAYMENT_TYPE_DEPOSIT) {
      return 2; // history tab
    }
    if (company.paymentMethod === PAYMENT_TYPE_TERM) {
      return 1;
    }
    if (company.paymentMethod === PAYMENT_TYPE_CASH) {
      return 0;
    }
  }

  return state.uiMyPayment.selectedTab;
};

const mapStateToProps = state => ({
  notificationOpen: state.uiWebUserMain.notificationDrawerOpen,
  selectedTab: state.uiMyPayment.selectedTab, // getSelectedTab(state),
  userCompany: state.currentUser.company,
  isDownloading: state.uiMyPayment.cancellingOutstandingOrderStatus,
  hasBothPaymentMethods: isShowCartTabs(state.currentUser.company),
  selectedInnerTab: state.uiMyPayment.selectedInnerTab,
});

const mapDispatchToProps = dispatch => ({
  onAppear: () => {
    dispatch(setMyPaymentSelectedInnerTab(CART_TAB_CIP));
  },
  onTabPressed: (selectedTab) => {
    dispatch(setTappedOutstandingItemNo(''));
    dispatch(setTappedTermBlNo(''));
    dispatch(setTappedPaymentHistoryProformaNo(''));
    if (selectedTab === 2) {
      dispatch(setMyPaymentHistorySearchText(''));
    }
    if (selectedTab === 3) {
      dispatch(setPredefinedOrderSearchText(''));
    }
    dispatch(setMyPaymentSelectedTab(selectedTab));
    if (selectedTab !== 2) {
      dispatch(setMyPaymentSelectedInnerTab(CART_TAB_CIP));
    }
  },
  onInnerTabPressed: (selectedTab) => {
    dispatch(setTappedOutstandingItemNo(''));
    dispatch(setTappedTermBlNo(''));
    dispatch(setTappedPaymentHistoryProformaNo(''));
    dispatch(setMyPaymentSelectedInnerTab(selectedTab));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPaymentBaseScreen);
